import { render, staticRenderFns } from "./iconPaperClip.vue?vue&type=template&id=b064bfc8"
import script from "./iconPaperClip.vue?vue&type=script&lang=js"
export * from "./iconPaperClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports